export default __webpack_public_path__ + "static/media/DrCyj.d4f47689.png";